import { DataSource } from "@godspeedsystems/plugins-axios-as-datasource";
export default DataSource;
